// extracted by mini-css-extract-plugin
module.exports = {"dateRange":"daterange-module--dateRange--1cRep"};